module.exports = __webpack_public_path__ + "img/bg_04.2edc54a0.png";